import { render, staticRenderFns } from "./ResponsabiliAntiriciclaggio.vue?vue&type=template&id=f8832e8e&"
import script from "./ResponsabiliAntiriciclaggio.vue?vue&type=script&lang=js&"
export * from "./ResponsabiliAntiriciclaggio.vue?vue&type=script&lang=js&"
import style0 from "./ResponsabiliAntiriciclaggio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports